module.exports = __webpack_public_path__ + "static/media/ansiedade.e374731b.png";